// refrescoContenido.js — «olvida lo que sabes y vuelve a preguntar».
//
// 🔴 El problema que resuelve, medido el 27.08.26 con la portada abierta y
// quieta durante 190 segundos: `actualidad.json`, `tv.json`,
// `radar.json`, `programas.json` y `editorial.json` se pedían **una vez
// cada uno y nunca más**. Lo único que se refrescaba solo era el tema que suena
// y la parrilla del día.
//
// Es decir: si la redacción publicaba algo, quien tuviera la web abierta no lo
// veía nunca. Y recargar tampoco servía —el navegador contestaba con su copia
// durante cinco minutos, y en el caso de TV desde `localStorage`, que sobrevive
// al F5—, así que la única salida era esperar.
//
// ⚠️ Esto NO es tiempo real y no pretende serlo. Nadie abre una conexión al
// servidor ni sondea cada pocos segundos: se aprovecha un momento que ya
// existe —volver a la pestaña— para preguntar si hay algo nuevo. Si alguien se
// queda mirando fijamente la misma pantalla, seguirá sin enterarse.
//
// ⚠️ Y no toca la caché del NAVEGADOR, que es la otra mitad del problema y ya
// no hace falta que toque: desde el 28.08.26 el servidor sirve estos JSON con
// `max-age=0, must-revalidate`, así que el navegador revalida por su cuenta y
// recibe un **304 en 0 bytes** cuando no ha cambiado nada.
//
// Hubo un `cache: "no-cache"` aquí mientras el servidor decía `max-age=300`.
// Se retiró al aplicarse la política nueva, y no solo por redundante: forzarlo
// desde el cliente **ignora** lo que decida el servidor. Si algún día vuelve a
// una caché corta por un buen motivo, la web debe respetarla. La política de
// caché se decide en un sitio. Ver `docs/CACHE_Y_REFRESCO.md`.
import { invalidar as olvidarActualidad } from "@/services/actualidad";
import { invalidar as olvidarCanalAbierto } from "@/services/canalAbierto";
import { invalidar as olvidarProgramas } from "@/services/programmes";
import { invalidar as olvidarTV } from "@/services/tvVideos";
import { invalidar as olvidarEditorial } from "@/services/editorialArtists";

/**
 * Olvida todo lo que la redacción puede haber cambiado.
 *
 * No pide nada: solo tira lo guardado. Quien llame a esto tiene que volver a
 * pedir los datos después — así se decide EN LA VISTA qué merece recargarse y
 * qué no, en vez de disparar cinco peticiones a ciegas.
 *
 * Se deja fuera lo que no depende de la redacción: los conciertos y los
 * artistas relacionados salen de fuentes externas por artista y cambian a su
 * ritmo, así que invalidarlos aquí sería pedir por pedir.
 */
export function olvidarContenido() {
  olvidarActualidad();
  olvidarCanalAbierto();
  olvidarProgramas();
  olvidarTV();
  olvidarEditorial();
}
